import { render } from "./Pause.vue?vue&type=template&id=95235a50"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Pause.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "95235a50"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('95235a50', __exports__)) {
    api.reload('95235a50', __exports__)
  }
  
  module.hot.accept("./Pause.vue?vue&type=template&id=95235a50", () => {
    api.rerender('95235a50', render)
  })

}


export default __exports__